import { render } from "./HeroiconsSolidTrendingDown.vue?vue&type=template&id=272c8038"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTrendingDown.vue"]])

export default __exports__